<template>
  <el-dialog
    :visible="dialogShow"
    title="修改公告"
    @open="open"
    @close="close"
    width="480px"
    :close-on-click-modal="false"
    center
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="ruleForm"
      label-position="top"
    >
      <el-form-item label="公告标题：" prop="title" class="title">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item label="公告内容：" prop="content">
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 10 }"
          v-model="ruleForm.content"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="notice-upload">
      <el-upload
        class="upload"
        :auto-upload="false"
        :action="action"
        list-type="picture-card"
        :file-list="fileList"
        accept=".jpg,.png,.jpeg"
        multiple
        ref="upload"
        :limit="3"
        :on-change="onChange"
        :on-remove="onRemove"
        :on-preview="handlePictureCardPreview"
        :on-exceed="onExceed"
      >
        <div class="iconfont icon-camera add"></div>
      </el-upload>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm"> 修改 </el-button>
    </div>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import axios from "axios";

import { baseURL } from "@/api/request"; // 服务器地址
export default {
  name: "",
  props: {
    noticeEditShow: {
      type: Boolean,
      default: false,
    },
    notice: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    noticeEditShow() {
      this.dialogShow = this.noticeEditShow;
    },
  },
  data() {
    return {
      dialogShow: false,
      ruleForm: {
        title: "",
        content: "",
      },
      rules: {
        title: [{ required: true, message: "请输入公告标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入公告内容", trigger: "blur" }],
      },
      maxlength: 1000,
      formData: "", // 文件上传参数
      action: "", // 文件上传路径
      // 预置图片、待提交的图片
      fileList: [],
      // 预览参数
      dialogImageUrl: "",
      dialogVisible: false,
      imgList: [],
    };
  },
  created() {
    // console.log(baseURL)
    this.action = `${baseURL}${this.$url.editNews}`;
  },
  methods: {
    open() {
      this.ruleForm.title = this.notice.title;
      this.ruleForm.content = this.notice.content;
      this.formData = "";
      this.fileList = [];
      // 如果该公告已有图片，将图片url转file
      if (this.notice.imgList && this.notice.imgList.length) {
        this.imgList = this.notice.imgList.split(",");
        this.imgList.map((item, index) => {
          this.imgToBase64(item);
        });
      }
    },
    close() {
      this.formData = "";
      this.fileList = [];
      this.$emit("update:noticeEditShow", false);
    },
    // 上传预览图片时调用
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 文件超出个数限制时
    onExceed(file, fileList) {
      return this.$message("最多可上传三张");
    },
    // 添加文件、上传成功和上传失败时都会被调用
    onChange(file, fileList) {
      let limit = file.size / 1024 / 1024 < 2;
      let file_type = file.name.split(".")[1];
      if (!/^(jpg|png|jpeg)$/g.test(file_type)) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("请选择jpg,png,jpeg类型文件");
      } else if (!limit) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("上传图片大小不能超过 2MB!");
      } else {
        this.fileList = fileList;
      }
    },
    // 移除图片时被调用
    onRemove(file, fileList) {
      this.fileList = fileList;
    },
    // 提交
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // new FormData()创建创建FormData对象
          this.formData = new FormData();

          // 有图片
          if (this.fileList.length) {
            // console.log(this.fileList);
            this.fileList.map((item) => {
              this.formData.append("file", item.raw);
            });
          }

          // 向FormData对象设置其他参数
          let user = this.user;
          // console.log(user);
          this.formData.append("id", this.notice.id);
          this.formData.append("updateBy", user.id);
          this.formData.append("title", this.ruleForm.title);
          this.formData.append("content", this.ruleForm.content);
          let config = {
            headers: {
              bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
              "Content-Type": "multipart/form-data",
            },
          };
          // 调用接口
          axios
            .put(this.action, this.formData, config)
            .then((res) => {
              // res.data 服务器返回的数据
              let data = res.data;
              console.log(data);
              if (res.status != 200) {
                return this.$message.error("修改失败");
              } else {
                if (data.code == 200) {
                  // 上传成功，刷新列表，关闭dialog
                  this.$emit("refresh");
                  this.close();
                  this.$message.success("修改成功");
                } else if (data.code == 401 || data.code == 403) {
                  // token失效
                  this.$message.error("获取用户信息失败，请重新登录");
                  this.$store.dispatch("user/resetToken");
                  this.$router.replace({
                    path: "login",
                    query: { redirect: this.$router.currentRoute.fullPath },
                  });
                } else {
                  this.$message.error("修改失败");
                }
              }
            })
            .catch((err) => {
              // console.log(err);
              return this.$message.error("修改失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
    // url转file文件, url转base64 base64转file对象
    imgToBase64(url) {
      let img_name = url
        .split("/")
        [url.split("/").length - 1].substring(
          0,
          url.split("/")[url.split("/").length - 1].length - 4
        ); //获取图片名称
      // console.log(url.split("/")[url.split("/").length - 1]);
      var canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.setAttribute("crossOrigin", "*");
      var dataURL = "";
      img.onload = () => {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        dataURL = canvas.toDataURL("image/jpg");
        // console.log(dataURL); //Base64码  一般用这个就行
        this.base64toFile(dataURL, img_name);
        canvas = null;
      };
      img.src = url;
    },
    //base64转file对象
    base64toFile(base, filename) {
      var arr = base.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var suffix = mime.split("/")[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let URL = window.URL || window.webkitURL;
      let obj = {
        name: `${filename}.jpg`,
        type: "image/jpg",
        raw: new File([u8arr], `${filename}.${suffix}`, { type: mime }),
        url: URL.createObjectURL(
          new File([u8arr], `${filename}.${suffix}`, { type: mime })
        ),
      };
      // 放到fileList
      this.fileList.push(obj);
      //转换成file对象
      return new File([u8arr], `${filename}.${suffix}`, { type: mime });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./notice-edit.scss";
</style>
